import client from './index'
const changePassword = (data) => client['api'].post(`user/changepassword`, data)
const getByUsername = (username) => client['api'].get(`/user/username/${username}`)
const getDataUserByType = (data) => client['api'].get(`users`, {params: data})
const postDataByProdi = (data) => client['api'].post(`myusers`, data)
const updateDataByProdi = (data,id) => client['api'].patch(`myusers/${id}`, data)
const changeRoleByProdi = (data,id) => client['api'].patch(`/myusers/changerole/${id}`, data)
const studentGuidanceResult = (data) => client['api'].get(`/students/guidances/result`, {params: data})
const lectureByProdi = (url) => client['api'].get(url)

const pushSubscription = (data) => client['api'].post(`/push`, data)
const resetPassword = (data) => client['api'].post(`/user/resetpassword`, data)
const changeStatusUser = (data) => client['api'].post(`/user/changeStatus`, data)

export {
    changePassword,
    getByUsername,
    getDataUserByType,
    postDataByProdi,
    updateDataByProdi,
    changeRoleByProdi,
    studentGuidanceResult,
    pushSubscription,
    resetPassword,
    changeStatusUser,
    lectureByProdi
}